/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import {
  Form,
  Col,
  Row,
  Select,
  Table,
  Button,
  Skeleton,
} from "antd";
import type { UploadProps } from "antd/es/upload/interface";
import { CreateModal } from "./create-modal";
import { useEffect, useState } from "react";
import { department } from "../../../../info-technology-process/data";
import type { ColumnsType } from "antd/es/table";
import { Routes } from "../../../../../../AppRoutes";
import { useHistory, useRouteMatch } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { Upload, DatePicker, Checkbox, Modal } from "antd";
import { IMaterialType } from "../../models";
import {
  additionalFormFields,
  eContent,
  formFields,
} from "../../constant/field-names";
import { HOChangePersonRequestService } from "../../../../../../services/human-organization/change-person-request.service";
import moment from "moment";
import { EditModal } from "./edit-modal";
import { StyledTitle } from "../../../../../../components/styled-antd/Title";
import { StyledButton } from "../../../../../../components/styled-antd";
import { RenderHelper } from "../../../summary-employee-request/utils/render-helper";
import { useExcelTemplate } from "../../../../../../components/input/arrayData/hooks/useExcelTemplate";
import { getTemplate } from "../../../../../../components/input/arrayData/excel-template";
import ExcelJS from "exceljs";
import { HiOutlineTrash } from "react-icons/hi2";
import _ from "lodash";

const { RangePicker } = DatePicker;

export function EditForm() {
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [fileList, setFileList] = useState<any[]>([]);
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [isMultiDelete, setIsMultiDelete] = useState(false);

  const { exportFile } = useExcelTemplate();

  const [form] = Form.useForm();
  const { id } = useRouteMatch().params as any;

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      form.setFieldsValue({
        eApprovedBy: null,
        pickedUser: null,
      });
    }
  };


  const columns: ColumnsType<IMaterialType> = [
    {
      title: isMultiDelete ? (
        <Checkbox
          onClick={(e: any) => {
            if (e.target.checked) {
              setListDelete(_.range(0, dataSource.length));
            } else {
              setListDelete([]);
            }
          }}
        />
      ) : (
        ""
      ),
      dataIndex: "action",
      key: "action",
      render: (value: any, record: IMaterialType, index: number) => {
        index = (currentPage - 1) * pageSize + index;

        if (isMultiDelete) {
          return (
            <Checkbox
              checked={listDelete.includes(index)}
              onChange={(e) => {
                if (e.target.checked) {
                  let newListDelete = [...listDelete, index];
                  setListDelete(newListDelete);
                } else {
                  let newListDelete = [...listDelete];
                  newListDelete = newListDelete.filter(
                    (value): any => value != index
                  );
                  setListDelete(newListDelete);
                }
              }}
            />
          );
        }

        return (
          <div className="d-flex">
            <EditModal
              dataSource={dataSource}
              setDataSource={setDataSource}
              index={index}
              parentValues={form.getFieldsValue()}
            />

            <Button
              onClick={() => {
                const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
                if ((dataSource.length - 1) % 10 == 0) {
                  if (currentPage >= 2 && currentPage === NUM_PAGES)
                    setCurrentPage(currentPage - 1);
                }

                setDataSource((prev) => {
                  return prev.filter(
                    (value, indexValue) => indexValue != index
                  );
                });
              }}
              className="ml-1"
            >
              <HiOutlineTrash
                size={20}
                className="cursor-pointer"
                color="#dc2626"
              />
            </Button>
          </div>
        );
      },
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: any, record: IMaterialType, index: number) => (
        <>{(currentPage - 1) * pageSize + index + 1}</>
      ),
    },
    {
      title: "Nhân sự/ mã NV đã đăng ký",
      dataIndex: eContent.registerPersonel,
      key: eContent.registerPersonel,
    },
    {
      title: "Nhân sự/ mã NV thay thế/ bổ sung",
      dataIndex: eContent.replacePersonel,
      key: eContent.replacePersonel,
    },
    {
      title: "Cơ quan/ Đơn vị",
      dataIndex: eContent.department,
      key: eContent.department,
    },
    {
      title: "Lý do thay đổi",
      dataIndex: eContent.reason,
      key: eContent.reason,
    },
    {
      title: "Ghi chú",
      dataIndex: eContent.note,
      key: eContent.note,
    },
  ];

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: async (file) => {
      if (file.name.split(".")[file.name.split(".").length - 1] != "xlsx") {
        CreateNotification({
          title: "Import file thất bại",
          body: `File sai định dạng`,
          icon: "/icons/error.png",
        });
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async () => {
        const buffer: any = reader.result;
        const workbooks = await workbook.xlsx.load(buffer);

        let data: any[] = [];

        workbooks.eachSheet((sheet, sheetId) => {
          sheet.eachRow((row: any, rowIndex) => {
            data.push([...row.values].filter((value, index) => index != 0));
          });
        });

        data = data.filter((value, index) => index != 0);

        const dataSource: any[] = [];

        for (const item of data) {
          // if (!Array.isArray(item) || item.length != 5) {
          //   CreateNotification({
          //     title: "Import file thất bại",
          //     body: `Vui lòng download biểu mẫu và nhập đúng thông tin.`,
          //     icon: "/icons/error.png",
          //   });
          //   return;
          // }

          dataSource.push({
            [eContent.registerPersonel]: item[0],
            [eContent.replacePersonel]: item[1],
            [eContent.department]: item[2],
            [eContent.reason]: item[3],
            [eContent.note]: item[4],
          });
        }

        setDataSource((prev) => [...prev, ...dataSource]);
        setFileList([...fileList, file]);
      };

      return false;
    },
    fileList,
    showUploadList: false,
  };

  const onFinish = async (values: any) => {
    if (dataSource.length === 0) {
      CreateNotification({
        title: "Thất bại",
        body: `Vui lòng nhập các thông tin yêu cầu`,
        icon: "/icons/error.png",
      });
      return;
    }

    try {
      let initFields: any = {
        eCourse: values.eCourse,
        eContent: JSON.stringify(dataSource),
        eMajor: values.eMajor,
        eCourseDate: values.eCourseStartEndDate[0],
        eCourseDateEnd: values.eCourseStartEndDate[1],
      };

      formFields.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      additionalFormFields.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      await HOChangePersonRequestService.updateChangePersonRequest(
        id,
        initFields
      );

      CreateNotification({
        title: "Thành công",
        body: `Chỉnh sửa yêu cầu thành công`,
        icon: "/icons/success.png",
      });
      history.push(Routes.courseStaffPage.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Chỉnh sửa yêu cầu thất bại`,
        icon: "/icons/error.png",
      });
      history.push(Routes.courseStaffPage.path);
    }
  };

  const downLoad = async () => {
    await exportFile(getTemplate("change-person"));
  };

  const [allValue, setAllValue] = useState({});

  const initialData = async () => {
    setLoading(true);
    const data =
      await HOChangePersonRequestService.getDetailsChangePersonRequest(id);
    setLoading(false);

    setDataSource(JSON.parse(data.fields.eContent));

    setAllValue({
      eCourse: data.fields.eCourse,
      eMajor: data.fields.eMajor,
      eTrainingType: data.fields.eTrainingType,
    });

    form.setFieldsValue({
      eReason: data.fields.eReason,
      ePhoneNumber: data.fields.ePhoneNumber,
      eDepartment: data.fields.eDepartment,
      eCourse: data.fields.eCourse,
      eCourseStartEndDate: [
        moment(data.fields.eCourseDate),
        moment(data.fields.eCourseDateEnd),
      ],
      eMajor: data.fields.eMajor,
      eTrainingType: data.fields.eTrainingType,

      eIssueNumber: data.fields.eIssueNumber,
      eIssueTimes: data.fields.eIssueTimes,
      eIssueEffectiveDate: moment(data.fields.eIssueEffectiveDate),
    });
  };

  useEffect(() => {
    initialData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [listDelete, setListDelete] = useState<number[]>([]);

  const pageSize = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  const confirmDelete = () => {
    const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
    if ((dataSource.length - listDelete.length) % 10 == 0) {
      if (currentPage >= 2 && currentPage === NUM_PAGES)
        setCurrentPage(currentPage - 1);
    }

    let newDataSource = [...dataSource];
    newDataSource = newDataSource.filter(
      (value, index) => !listDelete.includes(index)
    );
    setDataSource(newDataSource);

    setListDelete([]);
    setIsMultiDelete(false);
  };


  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        confirmDelete();
      },
    });
  };


  return (
    <>
      {" "}
      {loading && <Skeleton />}
      {!loading && (
        <Form
          onFinish={onFinish}
          size="large"
          form={form}
          onValuesChange={onValuesChange}
        >
          <Row gutter={[32, 0]}>
            <Col span={12}>
              <StyledTitle level={5}>
                Cơ quan/ Đơn vị <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name="eDepartment"
                rules={[{ required: true, message: "Chọn cơ quan đơn vị" }]}
              >
                <Select options={department} disabled />
              </Form.Item>
            </Col>

            <RenderHelper
              allValue={allValue}
              setAllValue={setAllValue}
              form={form}
              fields={formFields}
            />

            <Col span={12}>
              <StyledTitle level={5}>
                Chọn ngày <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name="eCourseStartEndDate"
                rules={[{ required: true, message: "Chọn cơ quan đơn vị" }]}
              >
                <RangePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col>
              <StyledTitle level={5}>
                Chi tiết <span className="text-danger">(*)</span>
              </StyledTitle>
            </Col>
          </Row>

          <Row>
            <Col>
              <CreateModal
                dataSource={dataSource}
                setDataSource={setDataSource}
                parentValues={form.getFieldsValue()}
              />
            </Col>

            <Col>
              {!isMultiDelete && (
                <StyledButton
                  bgColor="red"
                  className="ml-3"
                  type="primary"
                  danger
                  onClick={() => setIsMultiDelete(true)}
                >
                  Chọn nhiều để xóa
                </StyledButton>
              )}

              {isMultiDelete && (
                <StyledButton
                  className="ml-3"
                  onClick={() => {
                    setIsMultiDelete(false);
                    setListDelete([]);
                  }}
                  bgColor="green"
                >
                  Quay lại
                </StyledButton>
              )}

              {listDelete.length != 0 && (
                <Button
                  className="ml-3"
                  type="primary"
                  danger
                  onClick={showDeleteConfirm}
                >
                  Xóa dữ liệu đã chọn
                </Button>
              )}
            </Col>

            <Col>
              <Upload {...props}>
                <StyledButton bgColor="blue" className="mx-3">
                  Tải biểu mẫu{" "}
                </StyledButton>
              </Upload>
            </Col>

            <Col>
              <div className="mt-1">
                <a href="#" className="text-primary" onClick={downLoad}>
                  Download biểu mẫu tại đây
                </a>
              </div>
            </Col>
          </Row>

          <div style={{ overflowX: "scroll" }}>
            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={{
                onChange: (page) => {
                  setCurrentPage(page);
                },
                current: currentPage,
              }}
            />
          </div>

          <Row gutter={[32, 0]}>
            <RenderHelper fields={additionalFormFields} />
          </Row>

          <Row gutter={[32, 0]}>
            <Col span={24}>
              <div className="d-flex justify-content-center">
                <StyledButton
                  htmlType="submit"
                  bgColor="red"
                  type="primary"
                  danger
                  onClick={() => history.push(Routes.courseStaffPage.path)}
                >
                  Hủy
                </StyledButton>

                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  className="ml-3"
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
}
